export const appBaseURL = "/"

export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no"},{"name":"description","content":"Olamet Meet video chat with new people online ✔️ 1v1 chats ✔️ 1V1 video calls ✔️ find your next date ✔️make new friends."},{"name":"keywords","content":"Live Chat, meet new people, 1v1 video calls, online chatrooms, free video chat, webcam chat, random video chat, private video chat, olamet, Olamet"},{"name":"build-version","content":"1.1.9.16"}],"link":[],"style":[{"textContent":"html { background-color: #161616 }"}],"script":[{"src":"/cdn/js/lib-flexible@0.3.2.js"},{"src":"/cdn/js/AgoraRTC_N-4.24.2.js","defer":true},{"src":"/cdn/js/trtc-sdk-v5@5.9.0.js","defer":true},{"src":"/cdn/js/svgaplayerweb@2.3.2.min.js","defer":true},{"src":"/cdn/js/fingerprintjs@4.2.2.min.js","defer":true}],"noscript":[],"title":"Olamet - Meet new people and start wonderful video chat"}

export const appKeepalive = {"include":[]}

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = false

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false